(function () {

    "use strict";

    console.log("🚀 Bridge Started");

    function extractTrustShopData() {

        const summary = document.querySelector("#trustshop-rating-placeholder");
        const container = document.querySelector("#trustshop-review--container");

        if (!summary || !container) {
            return false;
        }

        const avg = summary.querySelector(".trustshop-review-summary--average");
        const total = summary.querySelector(".trustshop-review-summary--total");

        if (!avg || !total) {
            return false;
        }

        const reviews = [];

        container.querySelectorAll(".trustshop-review-item-type--grid").forEach(function (item) {

            const id = item.id.replace("trustshop-review-id--", "");

            const name =
                item.querySelector(".trustshop-review--author_name p")?.textContent.trim() || "";

            const initial =
                item.querySelector(".trustshop-author-avt--text")?.textContent.trim() || "";

            const review =
                item.querySelector(".trustshop-review--content span")?.textContent.trim() || "";

            const date =
                item.querySelector("time")?.textContent.trim() || "";

            const helpful =
                parseInt(
                    item.querySelector(".helpful-count")?.textContent.replace(/\D/g, "") || "0",
                    10
                );

            // Count filled stars
            const rating =
                item.querySelectorAll(".trustshop-rating-star--container svg").length;

            reviews.push({
                id,
                name,
                initial,
                rating,
                date,
                country: "India",
                review,
                helpful
            });

        });

        window.TRUSTSHOP_DATA = {

            rating: parseFloat(avg.textContent),

            count: parseInt(
                total.textContent.replace(/\D/g, ""),
                10
            ),

            reviews

        };

        console.log("✅ TRUSTSHOP_DATA");
        console.log(window.TRUSTSHOP_DATA);

        return true;
    }

    // Try immediately
    if (extractTrustShopData()) {
        return;
    }

    // Wait until TrustShop injects its HTML
    const observer = new MutationObserver(function () {

        if (extractTrustShopData()) {

            observer.disconnect();

            console.log("✅ Bridge Finished");

        }

    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

})();